export default function MySQL_DROPDB() {
  return (
    <div>
      <h2>MySQL_DROPDB</h2>    </div>
  );
}